import { create } from 'zustand';
import { useCases } from '../../infrastructure/di/container';
import { ChannelCategoryEntity } from '../../domain/entities/ChannelCategory';

interface ChannelCategoriesState {
  categories: ChannelCategoryEntity[];
  isLoading: boolean;
  error?: string;
  load: (force?: boolean) => Promise<void>;
}

export const useChannelCategoriesStore = create<ChannelCategoriesState>((set, get) => ({
  categories: [],
  isLoading: false,
  async load(force = false) {
    // справочник меняется только через импорт — кэшируем на сессию
    if (!force && get().categories.length > 0) return;
    set({ isLoading: true, error: undefined });
    try {
      const categories = await useCases.listChannelCategories().execute();
      set({ categories, isLoading: false });
    } catch (e: any) {
      set({ isLoading: false, error: e?.message || 'Failed to load channel categories' });
    }
  },
}));
